//  ##  ##     ##              ###    ##     ##  ##  ###    ###  #####
//  ##  ####   ##             ## ##   ####   ##  ##  ## #  # ##  ##
//  ##  ##  ## ##  ########  ##   ##  ##  ## ##  ##  ##  ##  ##  #####
//  ##  ##    ###            #######  ##    ###  ##  ##      ##  ##
//  ##  ##     ##            ##   ##  ##     ##  ##  ##      ##  #####
/*
画面に入った監視対象に.animatedを付加
animatedによってアニメーションするクラスは_anime.scssとそのスタイルガイドを参照
*/
window.intObs = function () {
  const jsInItems = document.querySelectorAll('.js-in:not(.animated)');
  const jsBottomItems = document.querySelectorAll('.js-bottomIn:not(.animated)');

  if (!jsInItems.length && !jsBottomItems.length) {
    return;
  }

  // -------------------------
  // js-in（従来設定）
  // -------------------------
  if (jsInItems.length) {
    const intObsOption = {
      rootMargin: '0px 0px -20% 0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    }, intObsOption);

    jsInItems.forEach(item => observer.observe(item));
  }

  // -------------------------
  // js-bottomIn（画面内に入ったら即）
  // -------------------------
  if (jsBottomItems.length) {
    const bottomObsOption = {
      rootMargin: '0px',
      threshold: 0,
    };

    const bottomObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
        }
      });
    }, bottomObsOption);

    jsBottomItems.forEach(item => bottomObserver.observe(item));
  }
};
window.intObs();

